import $ from 'jquery';

export default function language() {
  
  function changeLang() {
    var $languageList = $('.language .language__list');
    var $language = $('.language .language__current a');
    
    $languageList.hide();
    
    $language.on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('open').children('.fa').toggleClass('fa-angle-down fa-angle-up');
			$languageList.slideToggle();
    })
  }

  $( document ).ready(function() {
    if($('#language').length > 0) {
      changeLang();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/language.js